import React, { Component } from 'react';
import { Input, Modal, message } from 'antd';
import API_URL from '../../../../common/url';
import AjaxRequest from '../../../../common/AjaxRequest';

const { TextArea } = Input;

class RefuseProcess extends Component {
    state = {
        visible: false,
        loading: false,
        requirementId : '',
        reason : '',
    }

    show = requirementId => {
        this.setState({
            visible: true,
            requirementId: requirementId || '',
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    changeReason = e => {
        this.setState({ reason: e.target.value });
    }

    handleSubmit = () => {
        const { requirementId, reason } = this.state;
        
        if (!reason) {
            return message.warning("拒绝理由不能为空");
        }

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.rejectHandoverAssign,
            data: {
                requirementId,
                reason
            },
            doneResult: () => {
                message.success('操作成功');
                this.setState({
                    visible: false,
                    loading: false
                }, () => {
                    this.props.reload();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        AjaxRequest.sendRequest(options);
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title='需求分配明细'
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="650px"
            >
                <div style={{ textAlign: 'center' }}>
                    <label style={{ fontSize: '16px' }}>拒绝分配</label>
                </div>
                <br/>
                <div className="field-max">
                   <TextArea placeholder="请填写拒绝理由" value={this.state.reason} onChange={this.changeReason} rows={4} />
                </div>
            </Modal>
        );
    }
}

export default RefuseProcess;



// WEBPACK FOOTER //
// ./src/components/user/transfer/components/RefuseProcess.js